import { useTranslation } from "react-i18next";
import {
  ChatbotValue,
  ChatObject,
} from "../../../../../../services/api/instances/botApi/types";
import { AddChatAutocompleteBlock } from "../AddChatAutocompleteBlock";
import { NormalizedStorageObject } from "../../../../../../services/api/instances/storageApi/types/object_types";
import { TValueForService } from "../../../../../../services/api/instances/storageApi/types/service_types";
import { useChatsByRef } from "../../../../hook/use-chat-by-ref";
import { useChatListManager } from "../../../../hook/use-add-chat-autocomplete";
import { BotChatSelector } from "../../../BotChatSelector";
import styles from "./styles.module.css";
import { getUpdatedChatbotValue } from "../../../../helpers/getUpdatedChatbotValue";
import { getListWithoutId } from "../../../../helpers/getListWithoutId";

interface Props {
  bot: NormalizedStorageObject<ChatbotValue>;
  saveChatbotValue: (
    value: TValueForService<"ai_agents_telegram_bots">,
  ) => void;
}

export const ChatbotWhiteList = (props: Props) => {
  const { t } = useTranslation();
  const chats = useChatsByRef(props.bot?.value?.tg_bot_object?.ref);

  const initialWhiteList = props.bot?.value?.tg_bot_object?.white_list || [];
  const botRef = props.bot?.value?.tg_bot_object?.ref;

  const {
    selectedChatIds,
    handleAddBlock,
    handleDeleteBlock,
    handleUpdateBlock,
  } = useChatListManager(initialWhiteList, botRef);

  const syncWithBackend = (newIds: string[]) => {
    const validIds = newIds.filter((id) => id !== "");
    const currentBlackList = props.bot?.value?.tg_bot_object?.black_list ?? [];

    const newValue = getUpdatedChatbotValue(props.bot.value, {
      white_list: validIds,
      black_list: getListWithoutId(validIds, currentBlackList),
    });

    props.saveChatbotValue(newValue);
  };

  const handleDelete = (index: number) => {
    handleDeleteBlock(index);
    const nextIds = selectedChatIds.filter((_, i) => i !== index);
    syncWithBackend(nextIds);
  };

  const handleSelectChat = (index: number, newChat: ChatObject | null) => {
    const newId = newChat ? newChat.chat_id : "";
    handleUpdateBlock(index, newId);
    const nextIds = [...selectedChatIds];
    nextIds[index] = newId;

    syncWithBackend(nextIds);
  };

  return (
    <AddChatAutocompleteBlock
      bot={props.bot}
      saveChatbotValue={props.saveChatbotValue}
      chatType={"white_list"}
      handleAddNewChat={handleAddBlock}
      isDisabled={selectedChatIds.length >= chats.length}
      autocomplete={
        <>
          {selectedChatIds.map((chatId, index) => {
            const key = `${index}-${chatId}`;
            const chatObject = chats.find((c) => c.chat_id === chatId) || null;

            return (
              <div key={key} className={styles["row-wrapper"]}>
                <BotChatSelector
                  chats={chats}
                  chat={chatObject}
                  onSelectChat={(newChat) => handleSelectChat(index, newChat)}
                  emptyOptionLabel={t("chatbot.without_user")}
                  handleDeleteChatBlock={() => handleDelete(index)}
                />
              </div>
            );
          })}
        </>
      }
    />
  );
};
